import { api, auth } from "#/utils";
import { generateLocalStorage } from "#/utils/cache/generateLocalStorage";
import { Outlet } from "@monta/router-react";
import { useEffect } from "react";
import { Cookies } from "react-cookie";

interface ProtectedRouteProps {
  isAllowed: boolean;
}

const ProtectedRoute = (props: ProtectedRouteProps) => {
  const { isAllowed } = props;

  useEffect(() => {
    const accessToken = new Cookies().get("accessToken");
    if (accessToken && !isAllowed) auth.redirectToDefault();
  }, [isAllowed]);

  useEffect(() => {
    generateLocalStorage(api);
  }, []);

  return !isAllowed ? null : <Outlet />;
};

export default ProtectedRoute;
